import { render, staticRenderFns } from "./division_selection_step.vue?vue&type=template&id=66175138&"
import script from "./division_selection_step.vue?vue&type=script&lang=js&"
export * from "./division_selection_step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports